import React from 'react';
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from '../../ui/table';
import { Alert, AlertDescription } from '../../ui/alert';
import { formatAmount } from './format';

// DepositDetails shows the period's deposits per currency and what was measured (step 3).
export function DepositDetails({ deposits }) {
  return (
    <div className="space-y-3">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Currency</TableHead>
            <TableHead className="text-right">Deposits</TableHead>
            <TableHead className="text-right">Amount</TableHead>
            <TableHead className="text-right">USD</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {deposits.by_currency.map((d) => (
            <TableRow key={d.currency}>
              <TableCell className="font-bold">{d.currency}</TableCell>
              <TableCell className="text-right font-medium text-ink-dim">{d.count}</TableCell>
              <TableCell className="text-right font-bold">{formatAmount(d.amount)}</TableCell>
              <TableCell className="text-right font-medium text-ink-dim">{formatAmount(d.amount_usd)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {deposits.measured && (
        <p className="text-xs font-medium text-ink-dim">
          Measured <span className="font-bold text-ink">{formatAmount(deposits.measured, deposits.basis_currency)}</span>
          {' '}({deposits.basis_native ? 'single fiat currency' : 'USD equivalent'}
          {deposits.cc_exception_applied ? ', top currency only' : ''}) · eligible from{' '}
          {deposits.eligible_min}, exception band from {deposits.exception_min}
        </p>
      )}
      {deposits.note && (
        <Alert variant="warning"><AlertDescription>{deposits.note}</AlertDescription></Alert>
      )}
    </div>
  );
}
